import { Button, Image, Navbar } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { Link } from "react-router-dom";

import {
	faExternalLinkAlt,
	faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import AustinLogo from "../../assets/img/austinlogo.svg";
import { routes } from "../../constants";
import { WEBTITLE } from "../../utils";

export const Presentation = () => {
	const { isAuthenticated } = useAuth();
	return (
		<div style={{ height: "100vh" }}>
			<Navbar
				variant="dark"
				expand="lg"
				bg="secondary"
				className="navbar-transparent  navbar-theme-primary sticky-top"
			>
				<Navbar.Brand
					as={Link}
					to={routes.home.path}
					className="me-lg-3 d-flex align-items-center ps-2 ms-4"
				>
					<Image src={AustinLogo} />
					<span className="ms-2 text-gray-300 d-none d-md-inline">
						Austin Powder
					</span>
				</Navbar.Brand>
				<Link
					to={routes.dashboardOverview.path}
					className="text-dark me-3 ms-auto me-4"
				>
					<Button variant="charcoal-500">
						{isAuthenticated ? "My Account" : "Log in"}
						<FontAwesomeIcon
							icon={faExternalLinkAlt}
							className="d-none d-sm-inline ms-2"
						/>
					</Button>
				</Link>
			</Navbar>
			<section
				style={{ height: `calc(100% - 90px)` }}
				className="section-header overflow-hidden bg-primary text-white"
				id="home"
			>
				<div className="d-flex flex-column h-100 justify-content-center align-items-center">
					<div className="react-big-icon d-none d-lg-block">
						<FontAwesomeIcon icon={faLightbulb} />
					</div>
					<h1 className="fw-bolder">{WEBTITLE}</h1>
					<p className="text-muted fw-light mb-5 h5">
						The future of blasting
					</p>
				</div>
			</section>
			<footer className="footer-presentation bg-secondary text-white p-2">
				<div className="container">
					<div className="row">
						<div className="col mb-md-0">
							<div
								className="d-flex my-0 justify-content-center align-items-center"
								role="contentinfo"
							>
								<p className="text-center py-0 my-0 font-small">
									Copyright ©{" "}
									<a href="https://austinpowder.com">
										Austin Powder
									</a>
									<a> ✝ 2020 - 2025 | </a>
									<a href="mailto:paradigm@austinpowder.com">
										paradigm@austinpowder.com
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
};
